<div class="container">
    <que-templates-cards></que-templates-cards>
</div>